import { forceCheck } from 'react-lazyload';
import { useEventListener } from 'usehooks-ts';

import { throttle } from '@/helpers/throttle';

/**
 * Hook to force check lazy load on scroll event of a scrollable element.
 *
 * @param scrollableElement The element that should trigger lazy load check on scroll.
 */
export const useLazyLoadOnScroll = (scrollableElement: React.RefObject<HTMLElement | Document>) => {
  useEventListener('scroll', onScroll, scrollableElement as React.RefObject<HTMLElement>);
};

/* Helpers */
const onScrollEndThrottled = throttle(forceCheck, 100);

let suppressed = false;

/**
 * Temporarily stop forceCheck from firing on scroll, e.g. while a programmatic
 * scroll is repositioning the page — lazy-mounting rows mid-animation is what
 * causes the scroll position to jump.
 */
export const setLazyLoadScrollSuppressed = (value: boolean) => {
  suppressed = value;
};

const onScroll = () => {
  if (suppressed) return;
  onScrollEndThrottled();
};
